// extracted by mini-css-extract-plugin
module.exports = {"people":"People_people__2G5pI","admins":"People_admins__-019S"};